<div id="order" class="page-layout carded fullwidth inner-scroll">

    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- HEADER -->
        <div class="header accent"
             fxLayout="row" fxLayoutAlign="space-between center">

            <!-- APP TITLE -->
            <div fxLayout="row" fxLayoutAlign="start center">

                <button mat-icon-button class="mr-16" [routerLink]="'/portfolio'">
                    <mat-icon>arrow_back</mat-icon>
                </button>

                <div fxLayout="column" fxLayoutAlign="start start"
                     [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">
                    <div class="h2">
                        {{portfolioDoc.meta.client_name}} 
                    </div>
                    <div class="subtitle secondary-text">
                        <span>{{portfolioDoc.id}}</span>
                    </div>
                </div>
            </div>
            <!-- / APP TITLE -->
            <button mat-raised-button
                    class="save-product-button"
                    [disabled]="pForm.invalid || pForm.pristine"
                     (click)="saveDocument()">
                <span>SAVE DOCUMENT</span>
            </button>
        </div>
        <!-- / HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">

            <!-- CONTENT -->
            <div class="content">
                <form  name="form" [formGroup]="pForm" class="product w-100-p" fxLayout="column" fxFlex>
                    <mat-tab-group fxLayout="column" fxFlex>


                        <mat-tab label="Primary Info">
                           
                                <div class="products tab-content p-24" fusePerfectScrollbar>
                                    <app-portfolio-document-primary [portfolioDoc]="portfolioDoc"></app-portfolio-document-primary>
                                    </div>
                          
                           
                        </mat-tab>
                        <mat-tab label="Portfolio Info">
                          
                                <div class="products tab-content p-24" >
                                  <app-portfolio-document-info [portfolioDoc]="portfolioDoc"></app-portfolio-document-info>
                                    </div>
                           
                           
                        </mat-tab>
                
                        <mat-tab label="Document Delivery">
                         
                                <div class="products tab-content p-24" fusePerfectScrollbar>
                                <app-portfolio-document-delivery  [allDeliveryFrequency]="allDeliveryFrequency" [portfolioDoc]="portfolioDoc"></app-portfolio-document-delivery>
                                    </div>
                     
                           
                        </mat-tab>
                        <mat-tab label="Doc Builds">
                            <div class="products tab-content p-24" fusePerfectScrollbar>
                                <app-deliveries-table [document] ="portfolioDoc" [productType]="'enterprise'" ></app-deliveries-table>
                                </div>
                    </mat-tab>
                        <mat-tab disabled>
                            <ng-template mat-tab-label>
                                <button  mat-icon-button (click)="deleteDocumentModal()" >
                                    <mat-icon id="delete">cancel</mat-icon>
                                </button>
                            </ng-template>
                        </mat-tab>
                        
                    </mat-tab-group>
            </form>
         

            </div>
            <!-- / CONTENT -->

        </div>
        <!-- / CONTENT CARD -->

    </div>
    <!-- / CENTER -->
</div>